// Globals
import dayjs from 'dayjs';

// Models
import { IBanner } from '@/models/banners.model';
import { SupportedLocales } from '@/models/localization.model';

const initialLocale = {
  [SupportedLocales.UK]: {
    title: '',
    link: '',
    description: '',
  },
  [SupportedLocales.RU]: {
    title: '',
    link: '',
    description: '',
  },
};

export const normalizeBannerValues = (initialValues: IBanner, isEdit: boolean) => {
  const normalizedData = {
    ...initialValues,
    active: !!initialValues?.active ? '1' : '0',
    start_date: dayjs(initialValues?.start_date),
    expiration_date: dayjs(initialValues?.expiration_date),
  };
  return isEdit && initialValues ? normalizedData : { locale: initialLocale };
};
